import { render } from "./SlotHistory.vue?vue&type=template&id=ee675600&scoped=true"
import script from "./SlotHistory.vue?vue&type=script&lang=js"
export * from "./SlotHistory.vue?vue&type=script&lang=js"

import "./SlotHistory.vue?vue&type=style&index=0&id=ee675600&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee675600"]])

export default __exports__